import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import AISolutions from "@/pages/AISolutions";
import TalentSolutions from "@/pages/TalentSolutions";
import ProductEngineering from "@/pages/ProductEngineering";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function NotFound() {
    return (
        <section className="min-h-[60vh] grid place-items-center pt-32 pb-20">
            <div className="text-center px-6">
                <p className="text-xs uppercase tracking-[0.22em] text-[#FF4040] font-semibold">
                    404
                </p>
                <h1 className="pqx-display text-4xl md:text-5xl mt-4 text-[#303030]">
                    Page not found
                </h1>
                <p className="mt-4 text-[#303030]/65 max-w-md mx-auto">
                    The page you were looking for has moved or no longer exists.
                </p>
                <a href="/" className="mt-7 inline-flex pqx-btn-primary">
                    Back to home
                </a>
            </div>
        </section>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/ai-solutions" element={<AISolutions />} />
                        <Route path="/talent-solutions" element={<TalentSolutions />} />
                        <Route path="/product-engineering" element={<ProductEngineering />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/products/:slug" element={<ProductDetail />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/industries/:slug" element={<IndustryDetail />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    classNames: {
                        toast: "pqx-toast",
                        title: "pqx-toast-title",
                        description: "pqx-toast-desc",
                    },
                }}
            />
        </div>
    );
}

export default App;
